import { StringParam, useQueryParams } from '@/hooks/useQueryParams';
import useSession from '@/hooks/useSession';
import { useResource, useResources } from '@/lib/datx-jsonapi-react';
import { queryProfileTimezones } from '@/queries/profile-timezones';
import { queryThinEvent } from '@/queries/thin-events';

export const useUserEventTimezone = (eventId: string): string => {
  const { timeZone } = useQueryParams<{ timeZone: string }>({
    timeZone: StringParam,
  });

  const { thinProfile: profile } = useSession();
  const { data: event } = useResource(queryThinEvent(eventId));
  const { data: profileTimezone } = useResources(queryProfileTimezones(eventId, profile?.id));

  if (timeZone) return timeZone;
  return profileTimezone?.[0]?.timeZone || event?.timeZone;
};
